import { render, staticRenderFns } from "./kisiadresara.vue?vue&type=template&id=77e8eb30&"
import script from "./kisiadresara.vue?vue&type=script&lang=js&"
export * from "./kisiadresara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports